import config from './config';
import { profile } from "../stores/storages/ProfileStorage";
import { clientInfo } from '../version'
import formatter from './formatter'
import api from './api'
const BlockChatServices = {
    getListBlock: async () => {
        const { token, username: msisdn } = profile.authAPI;
        const timestamp = new Date().getTime()
        const clientType = clientInfo.platform
        const security = formatter.encrypt(`${msisdn}${clientType}${token}${timestamp}`)
        const data = await BlockChatServices.getBlockList({
            params: {
                msisdn,
                clientType,
                timestamp,
                security,
            },
        }, { decrypt: true })       

        const res = data ? data.blockChat : []
        return res;
    },

    setBlockList: async (data, options) => {
        const res = await api.request({
            method: config.endpoints.chat.block.method,
            path: config.endpoints.chat.block.path,
            host: config.host,
            data,
            options,
        })
        return res
    },
    getBlockList: async (data, options) => {
        const res = await api.request({
            method: config.endpoints.chat.blockList.method,
            path: config.endpoints.chat.blockList.path,
            host: config.host,
            data,
            options,
        })
        return res
    },

    switchBlockChat: async (topicSelected, isBlock) => {
        const { token, username: msisdn } = profile.authAPI;
        const timestamp = new Date().getTime()
        const clientType = clientInfo.platform
        const revision = clientInfo.revision
        const languageCode = clientInfo.language
        const countryCode = clientInfo.country
        const desktop = 1
        let blockNewList = []
        let status = 1
        const blockUserLists = await BlockChatServices.getListBlock()
        if (Array.isArray(blockUserLists) && blockUserLists && blockUserLists.length >= 0) {
            profile.listBlockChat = blockUserLists
            if (isBlock) {
                status = 1
            } else {
                status = 0
            }
            blockNewList = JSON.stringify([
                ...blockUserLists.filter(c => c !== topicSelected).map(c => ({
                    msisdn: c,
                    status: 1,
                })),
                {
                    msisdn: topicSelected,
                    status,
                },
            ])
        }
        const security = formatter.encrypt(`${msisdn}${clientType}${blockNewList}${revision}${languageCode}${countryCode}${desktop}${token}${timestamp}`)
        const formData = new FormData()
        formData.append('msisdn', msisdn)
        formData.append('blocklist', blockNewList)
        formData.append('clientType', clientType)
        formData.append('revision', revision)
        formData.append('languageCode', languageCode)
        formData.append('countryCode', countryCode)
        formData.append('desktop', desktop)
        formData.append('timestamp', timestamp)
        formData.append('security', security)

        const data = await BlockChatServices.setBlockList(formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            decrypt: false,
        })
        data.statusBlock = status;
        if (data && data.code === 200) {
            if (status === 0) {
                profile.listBlockChat = blockUserLists.filter(c => c !== topicSelected)
            } else if (status === 1) {
                profile.listBlockChat = blockUserLists.filter(c => c !== topicSelected).concat(topicSelected)
            }
        }
        return data;
    }
}
export default BlockChatServices